import {useHistory, useRouteMatch} from "react-router-dom";
import {hashHistory} from "react-router"; // omg pls don't kill me for that

import {setWizardActiveItem, setWizardActiveStep, setWizardSelectedValues} from "../../../actions/wizardFunctions";
import store from "../../../store";
import {
  getAvailableSteps,
  getCurrentGroups,
  getDefaultMaterialsWizardItem, getFeatureGroupFromWizardGroup, getWizardGroupFromCurrentSteps, navItemIsExcluded
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import Misc from "../../../misc/misc";
import {ROUTES} from "../../../routes";
import {IS_LIXIL_UI} from "../../../config";
import {
  getNextWizardSteps,
  isSameVisualizerWizard, selectedWizardGroupIsNotInCurrentStepAnymore
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import {showWizardStepDoneCheckMark} from "./materialsWizardDoneCheckMark";

export const getNextNotCheckedStep = () => {

  const {wizardState, cartState, quotesState} = store.getState();
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, wizardAllowSkipDoneSteps} = wizardState;
  const {cartItems} = cartState;
  const {activeQuoteIndex} = quotesState;

  let nextStep = wizardActiveStep + 1;

  if (!wizardAllowSkipDoneSteps) {
    return nextStep // use new logic with skip only first time
  }

  // if (!wizardSelectedValues[nextStep]) { // if the next step is free - just go next, otherwise - let's find where to jump
  //   changeWizardStepRoute(nextStep);
  //   return
  // }
  const wizardSteps = getNextWizardSteps(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
  while (nextStep <= wizardSteps.length - 1) {
    if (!wizardSteps[nextStep]) {
      break;
    }
    const wizardGroup = wizardSteps[nextStep].stepGroups[0];
    const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
    const showDoneCheckMark = showWizardStepDoneCheckMark(wizardSelectedValues[nextStep], featureGroup, cartItems, activeQuoteIndex, wizardSteps[nextStep].stepGroups);
    // console.log("showDoneCheckMark", wizardGroup, featureGroup, showDoneCheckMark);
    if (!showDoneCheckMark) {
      break;
    }
    // console.log("activePartRelatedItemIndex skipped", activePartRelatedItemIndex);
    nextStep = nextStep + 1;
  }
  return nextStep
}

const getSkippedWizardValues = (nextStep, wizardActiveStep, wizardItem, wizardSelectedValues) => {
  if (nextStep > wizardActiveStep) {

    const wizardSteps = getAvailableSteps(wizardItem, wizardSelectedValues, true);
    wizardSteps.forEach((step, stepIndex) => {
      if ((stepIndex < nextStep) && (!wizardSelectedValues[stepIndex]
        || selectedWizardGroupIsNotInCurrentStepAnymore(wizardSelectedValues[stepIndex], step.stepGroups))) {
        const wizardGroup = step.stepGroups[0];
        if (wizardGroup) {
          const skippedValue = {
            [stepIndex]: {
              wizardGroup,
            }
          }
          store.dispatch(setWizardSelectedValues(skippedValue, false, wizardItem));
          wizardSelectedValues = Object.assign(wizardSelectedValues, skippedValue); // this is needed for code below
        }
      }
    });
  }
  return wizardSelectedValues
}

/**
 * is used for SQFT to prevent bug when advanced quoting is missing selected value
 * @param cartItems {[cartItemInterface]}
 */
export const setWizardValuesFromCartItems = (cartItems) => {
  const {wizardSelectedValues, wizardActiveItem} = store.getState().wizardState;
  if (!wizardActiveItem || !cartItems.length) {
    return
  }
  let shouldUpdate = false;
  let wizardValues = Object.assign({}, wizardSelectedValues);
  const wizardSteps = getAvailableSteps(wizardActiveItem, wizardSelectedValues, true);
  // console.log("wizardSteps", wizardSteps);
  // console.log("cartItems", cartItems);
  // console.log("wizardValues", wizardValues);
  cartItems.forEach((cartItem) => {
    if (!cartItem.fromWizardGroupId
      || !Number.isInteger(cartItem.fromWizardStep)
      || !cartItem.fromWizardId || (cartItem.fromWizardId !== wizardActiveItem.id)
      || wizardValues[cartItem.fromWizardStep]) {
      return
    }
    if (wizardSteps[cartItem.fromWizardStep] && wizardSteps[cartItem.fromWizardStep].stepGroups) {
      const wizardGroup = wizardSteps[cartItem.fromWizardStep].stepGroups.find(wG => wG.id === cartItem.fromWizardGroupId)
      // yes, we added a cart item from the wizard step, we should select it
      if (wizardGroup) {
        wizardValues[cartItem.fromWizardStep] = {
          wizardGroup,
        }
        if (!navItemIsExcluded({part: cartItem.cartFeature}, wizardGroup)) {
          wizardValues[cartItem.fromWizardStep].selectedFeature = cartItem.cartFeature;
          wizardValues[cartItem.fromWizardStep].partId = cartItem.partId;
        }
        shouldUpdate = true;
      }
    }
  });
  wizardSteps.forEach(wizardStep => { // here we are checking steps that should be skipped!
    // because they are already selected in another similar wizard group
    if (!wizardValues[wizardStep.stepIndex]
      && wizardStep.stepGroups.length === 1
      && wizardStep.stepGroups[0].hidePriceNoCart) {
      const similarSelectedWizardStep = Object.keys(wizardValues).find(key => {
        return wizardValues[key].wizardGroup
          && (wizardValues[key].wizardGroup.groupName === wizardStep.stepGroups[0].groupName)
          && (cartItems.some(cartItem => {
            return cartItem.fromWizardGroupId === wizardValues[key].wizardGroup.id
              && (wizardValues[key].selectedFeature === cartItem.cartFeature) // make 100% sure!
          }))
      });
      if (similarSelectedWizardStep) {
        wizardValues[wizardStep.stepIndex] = { // make it selected too
          wizardGroup: wizardStep.stepGroups[0], // with it's own wizard group
          partId: wizardValues[similarSelectedWizardStep].partId, // but with same values
          selectedFeature: wizardValues[similarSelectedWizardStep].selectedFeature,  // but with same values
        }
        if (!shouldUpdate) {
          shouldUpdate = true;
        }
      }
    }
  })
  if (shouldUpdate) {
    // console.log("shouldUpdate", wizardValues);
    store.dispatch(setWizardSelectedValues(wizardValues, true, wizardActiveItem));
  }
}

export const switchToWizardItem = (wizardItem, nextStep, quoteIndex, wizardGroupId = null, changeRoute = true) => {
  const {quotesState, wizardState} = store.getState();
  const {allWizardsValues, wizardActiveStep} = wizardState;

  if (!wizardItem) {
    wizardItem = getDefaultMaterialsWizardItem();
  }

  let wizardValues = {};
  const foundWizardSelectedObject = allWizardsValues.find(wizSelObject => {
    return (wizSelObject.quoteIndex === quotesState.activeQuoteIndex) && (wizSelObject.wizardItemId === wizardItem.id)
      && isSameVisualizerWizard(wizSelObject)
  });
  if (foundWizardSelectedObject) {
    wizardValues = Object.assign({}, foundWizardSelectedObject.wizardSelectedValues);
    wizardValues = getSkippedWizardValues(nextStep, wizardActiveStep, wizardItem, wizardValues);
  }
  store.dispatch(setWizardActiveItem(wizardItem, quoteIndex));
  store.dispatch(setWizardSelectedValues(wizardValues, true, wizardItem));
  if (Number.isInteger(nextStep)) {
    if (wizardGroupId) {
      const {neededStep} = getWizardGroupFromCurrentSteps(wizardItem, wizardValues, wizardGroupId);
      if (neededStep && (neededStep.stepIndex !== nextStep)) {
        nextStep = neededStep.stepIndex
      }
    }
    store.dispatch(setWizardActiveStep(nextStep));
  } else {
    nextStep = foundWizardSelectedObject && Number.isInteger(foundWizardSelectedObject.lastVisitedStep)
      ? foundWizardSelectedObject.lastVisitedStep // restore last step
      : wizardValues ? Object.keys(wizardValues).length : 0 // restore last step (just in case lastVisitedStep is missing)
    if (nextStep === 0 && wizardActiveStep !== 0) {
      store.dispatch(setWizardActiveStep(0)); // cases when someone changes the wizard
    }
  }
  if (!changeRoute) {
    return
  }
  const urlStepNumber = nextStep + 1; // because we don't want to have 0 in the URL
  const nextUrl = "/materials/" + Misc.getUrlFromString(wizardItem.name) + "/" + urlStepNumber;
  const currentHash = window.location.hash.split("#")[1];
  if (!currentHash || (currentHash !== nextUrl)) {
    hashHistory.push(nextUrl);
  }
}

export const useChangeWizardStepRoute = () => {

  let history = useHistory();
  let routeMatch = useRouteMatch();
  // {
  // isExact: true,
  // params: {partName: 'kitchen-cabinets', subPartName: '1'},
  // path: "/materials/:partName/:subPartName",
  // url: "/materials/kitchen-cabinets/3/upper-cabinet-boxes"
  // }
  // let {partName, subPartName} = routeMatch.params;
  let {partName} = routeMatch.params;

  const changeWizardStepRoute = (nextStep, propsWizardItem) => {

    const {wizardActiveItem, wizardActiveStep, wizardList} = store.getState().wizardState;
    let {wizardSelectedValues} = store.getState().wizardState;

    const currentWizardItem = propsWizardItem || wizardActiveItem;

    wizardSelectedValues = getSkippedWizardValues(nextStep, wizardActiveStep, currentWizardItem, wizardSelectedValues);

    const currentGroups = getCurrentGroups(currentWizardItem, nextStep, wizardSelectedValues);

    if (wizardActiveStep > -1 && !currentGroups.length) { // wizard finished! congratulations
      const currentWizardIndex = wizardList.findIndex(wizardItem => wizardItem.id === currentWizardItem.id);

      if (nextStep === -1 && wizardActiveStep === 0) { // go to the previous wizard
        const prevEnabledWizard = wizardList.find((wizardItem, wizardItemIndex) => {
          return (wizardItem.id !== currentWizardItem.id) && (wizardItemIndex < currentWizardIndex)
        });
        if (prevEnabledWizard) {
          switchToWizardItem(prevEnabledWizard);
        } else {
          history.push(ROUTES.quoteDesign);
        }
        return;
      }

      const nextEnabledWizard = wizardList.find((wizardItem, wizardItemIndex) => {
        return (wizardItem.id !== currentWizardItem.id) && (wizardItemIndex > currentWizardIndex)
      });
      if (nextEnabledWizard) {
        switchToWizardItem(nextEnabledWizard);
      } else {
        history.push(ROUTES.shoppingcart);
      }
      return;
    }

    // console.log("nextStep", nextStep);
    store.dispatch(setWizardActiveStep(nextStep));

    if (IS_LIXIL_UI) {
      return; // no need to change url
    }

    // console.log("subPartName", subPartName);
    // console.log("partName", partName);
    // console.log("history", history);

    if (!partName) {
      partName = Misc.getUrlFromString(currentWizardItem.name)
    }

    const wizardGroup = currentGroups[0];
    if (!wizardGroup) {
      console.info("no wizard group found, something is wrong with the wizard", );
      return
    }
    const stepUrl = Misc.getUrlFromString(wizardGroup.customDisplayName || wizardGroup.groupName || "");

    const urlStepNumber = nextStep + 1; // because we don't want to have 0 in the URL
    history.push("/materials/" + partName + "/" + urlStepNumber + (stepUrl ? "/" + stepUrl : ""));
  }

  return {changeWizardStepRoute}
}
